// This is only used for unit testing purposes since it's difficult to mock window.location
export function setHref(url) {
  window.location.href = url;
}